import { render } from "./pricing-table.vue?vue&type=template&id=c73ebb1e&scoped=true"
import script from "./pricing-table.vue?vue&type=script&lang=js"
export * from "./pricing-table.vue?vue&type=script&lang=js"

import "./pricing-table.vue?vue&type=style&index=0&id=c73ebb1e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73ebb1e"]])

export default __exports__